/* Office Walker owner hub + guides, 2026-10-01.

   1. Serial. The QR on the serial label opens /setup?sn=<serial>, which
      redirects here with ?sn= kept. The serial is shown on the page and
      remembered on this device, so a guide opened later still knows it.
      Only letters, digits, dot, dash and underscore, 3 to 40 characters.
   2. Support email. Every [data-owh-mail] link becomes a mailto: to the
      Odoo Helpdesk address, with the serial and the topic in the subject.
      Sent from the owner's own mail account, so Odoo files the ticket on the
      customer who bought it.
   3. Copy address, for phones with no mail app set up.
   4. Click-to-load YouTube (youtube-nocookie.com), nothing loads before play. */
(function () {
  'use strict';
  if (window.__owhBound) return;
  window.__owhBound = true;

  var KEY = 'owSerial';
  var OK = /^[A-Za-z0-9._-]{3,40}$/;

  function readSerial() {
    var sn = '';
    try { sn = new URLSearchParams(window.location.search).get('sn') || ''; } catch (e) {}
    sn = sn.trim();
    if (OK.test(sn)) {
      try { window.localStorage.setItem(KEY, sn); } catch (e) {}
      return sn;
    }
    try { sn = window.localStorage.getItem(KEY) || ''; } catch (e) { sn = ''; }
    return OK.test(sn) ? sn : '';
  }

  function mailHref(el, sn) {
    var to = el.getAttribute('data-to') || '';
    var prefix = el.getAttribute('data-prefix') || 'Office Walker';
    var topic = el.getAttribute('data-topic') || '';
    var body = (el.getAttribute('data-body') || '').replace(/\\n/g, '\n');
    var parts = [prefix];
    if (sn) parts.push(sn);
    if (topic) parts.push(topic);
    var subject = parts.join(' \u00b7 ');
    if (sn) body = body.replace('{serial}', sn); else body = body.replace(/^.*\{serial\}.*$\n?/m, '');
    return 'mailto:' + to + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }

  function init() {
    var sn = readSerial();

    var chips = document.querySelectorAll('[data-owh-serialwrap]');
    for (var i = 0; i < chips.length; i++) {
      if (sn) {
        var v = chips[i].querySelector('[data-owh-serial]');
        if (v) v.textContent = sn;
        chips[i].hidden = false;
      }
    }

    var mails = document.querySelectorAll('[data-owh-mail]');
    for (var j = 0; j < mails.length; j++) mails[j].setAttribute('href', mailHref(mails[j], sn));
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var copy = t.closest('[data-owh-copy]');
    if (copy) {
      var addr = copy.getAttribute('data-owh-copy');
      var label = copy.querySelector('[data-owh-copylabel]');
      var done = function () {
        if (!label) return;
        var was = label.textContent;
        label.textContent = copy.getAttribute('data-copied') || 'Copied';
        setTimeout(function () { label.textContent = was; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(addr).then(done, function () {});
      } else {
        var ta = document.createElement('textarea');
        ta.value = addr; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch (err) {}
        ta.remove();
      }
      return;
    }

    var yt = t.closest('[data-owh-yt]');
    if (yt) {
      var id = yt.getAttribute('data-owh-yt');
      if (!/^[A-Za-z0-9_-]{6,20}$/.test(id)) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
      f.title = yt.getAttribute('aria-label') || 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.setAttribute('allowfullscreen', '');
      yt.parentNode.replaceChild(f, yt);
    }
  });

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
